export const RATE_LIMIT_MESSAGE = 'Too many AI requests, try again in a minute';

/** HTTP status of an axios error or an `HttpError`, if any. */
export const statusOf = (err: unknown): number | undefined => {
  const e = err as { status?: unknown; response?: { status?: unknown } } | null;
  const status = e?.response?.status ?? e?.status;
  return typeof status === 'number' ? status : undefined;
};

/** True for an aborted request (axios `ERR_CANCELED` or a fetch `AbortError`). */
export const isAbort = (err: unknown): boolean => {
  const e = err as { code?: unknown; name?: unknown } | null;
  return e?.code === 'ERR_CANCELED' || e?.name === 'CanceledError' || e?.name === 'AbortError';
};

/** The server's `message` (string or list) when it sent one. */
export const serverMessage = (err: unknown): string | undefined => {
  const message = (err as { response?: { data?: { message?: unknown } } } | null)?.response?.data
    ?.message;
  if (typeof message === 'string' && message) return message;
  if (Array.isArray(message) && message.length) return message.join(', ');
  return undefined;
};
